function useMyTeamLeaveBenefit() {
  return {};
}

export default useMyTeamLeaveBenefit;
